import { isAxiosError } from 'axios';
import { FisExamStatus } from '../../types/exam';

export const extractErrorMessage = (err: unknown): string =>
  isAxiosError(err)
    ? (err.response?.data?.message ?? 'Something went wrong.')
    : 'Something went wrong.';

export const formatMoney = (amount: number | null, currency: { code: string } | null) =>
  amount == null
    ? '—'
    : `${currency?.code ?? ''} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();

export interface ExamListFilterValues {
  search: string;
  universityId: number | '';
  intakeId: number | '';
  counselorId: number | '';
}

export const EMPTY_EXAM_FILTERS: ExamListFilterValues = {
  search: '',
  universityId: '',
  intakeId: '',
  counselorId: '',
};

export const FIS_STATUS_LABEL: Record<FisExamStatus, string> = {
  REGISTERED: 'Registered',
  SAT: 'Sat the exam',
  PASSED: 'Passed',
  FAILED: 'Failed',
  ABSENT: 'Absent',
  WITHDRAWN: 'Withdrawn',
};
